import { MarkDownA } from "./MarkDownA";
import { MarkDownLi } from "./MarkDownLi";
export var markdownComponentsController = {
    li: MarkDownLi,
    a: MarkDownA
};
//# sourceMappingURL=markdownComponentsController.js.mapimport { MarkDownA } from "./MarkDownA";
import { MarkDownLi } from "./MarkDownLi";
export var markdownComponentsController = {
    li: MarkDownLi,
    a: MarkDownA
};
//# sourceMappingURL=markdownComponentsController.js.map